import { Component, Inject, Input, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ImageDialogComponent } from "../image-dialog/image-dialog.component";

@Component({
  selector: "tic-image-gallery",
  templateUrl: "./image-gallery.component.html",
  styleUrls: ["./image-gallery.component.scss"],
})
export class ImageGalleryComponent {
  constructor(
    private dialogRef: MatDialogRef<ImageGalleryComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data?: any
  ) {}

  onHandleClick() {
    this.dialogRef.close();
  }

  openDialog(imageUrl: string): void {
    this.dialog.open(ImageDialogComponent, {
      width: "auto",
      data: { imageUrl: imageUrl },
    });
  }
}
